import type {ProductPrice} from '../../catalog/models/ProductPrice';
import {Spinner} from 'react-bootstrap';
import React from 'react';

interface Props {
  loading?: boolean,
  error?: any;
  price: ProductPrice;
}

export const ProductPriceUI = ({ loading, error, price }: Props) => {
  if (loading === true) {
    return (
      <div className="d-flex align-items-center">
        <Spinner size="sm" />
      </div>
    );
  }
  if (error) {
    return (
      <small className="text-danger">
        No se pudo encontrar precio. Por favor, reintente más tarde
      </small>
    );
  }

  return (
    <>
      {
        price?.sellingPrice ? (
          <div>
            <strong className="fs-5">{price?.sellingPrice.toFixed(2)}€</strong>
            &nbsp;
            {
              price?.sellingPrice < price?.basePrice && (
                <small className="text-danger text-decoration-line-through">
                  {price?.basePrice.toFixed(2)}€
                </small>
              )
            }
          </div>
        ) : (
          <span className="text-warning">Precio online no disponible</span>
        )
      }
    </>
  );
};